var map = {
	"./1.png": 5012,
	"./2.png": 5993,
	"./3.png": 9009,
	"./4.png": 6861,
	"./5.png": 9831,
	"./6.png": 1160,
	"./7.png": 8833,
	"./8.png": 4288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4150;